var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "point-page" }, [
    _vm.type === "edit"
      ? _c("div", { staticClass: "reject_box" }, [
          _c(
            "div",
            { staticClass: "sub_title" },
            [
              _c("svg-icon", { attrs: { "icon-class": "warning" } }),
              _vm._v("  Approval Instructions\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "refusalReason" }, [
            _vm._v(_vm._s(_vm.pageData.refusalReason)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "sub_title img" }, [
          _vm._v("\n      Basic Information\n      "),
          ["OIL", "ALL"].includes(_vm.pageData.type)
            ? _c("img", {
                staticStyle: {
                  width: "0.66rem",
                  height: "0.24rem",
                  "margin-left": "0.15rem",
                },
                attrs: {
                  src: require("@/assets/image/well/oil.png"),
                  alt: "",
                  srcset: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          ["GAS", "ALL"].includes(_vm.pageData.type)
            ? _c("img", {
                staticStyle: {
                  width: "0.66rem",
                  height: "0.24rem",
                  "margin-left": "0.15rem",
                },
                attrs: {
                  src: require("@/assets/image/well/gas.png"),
                  alt: "",
                  srcset: "",
                },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "addWellForm",
            staticClass: "page-form point-form",
            attrs: {
              model: _vm.pageData,
              rules: _vm.pageRules,
              "label-position": "top",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 40 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "nickname", label: "Well Name" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            "auto-complete": "off",
                            placeholder: "Please fill in",
                          },
                          model: {
                            value: _vm.pageData.nickname,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageData, "nickname", $$v)
                            },
                            expression: "pageData.nickname",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.type === "edit"
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Unique ID" } },
                          [
                            _c("account", {
                              attrs: { value: _vm.getId(_vm.pageData) },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 24 } }),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "UWI", label: "AER UWI" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            "auto-complete": "off",
                            placeholder: "Please fill in",
                            disabled: _vm.type !== "edit",
                          },
                          model: {
                            value: _vm.pageData.UWI,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageData, "UWI", $$v)
                            },
                            expression: "pageData.UWI",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "fromToIDIdentifier",
                          label: "FromToIDIdentifier",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            "auto-complete": "off",
                            placeholder: "Please fill in",
                            disabled: _vm.type !== "edit",
                          },
                          model: {
                            value: _vm.pageData.fromToIDIdentifier,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageData, "fromToIDIdentifier", $$v)
                            },
                            expression: "pageData.fromToIDIdentifier",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showFlag
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "sulphur",
                              label: "Sulphur Content",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  type: "text",
                                  "auto-complete": "off",
                                  placeholder: "Please fill in",
                                },
                                model: {
                                  value: _vm.pageData.sulphur,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pageData, "sulphur", $$v)
                                  },
                                  expression: "pageData.sulphur",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showFlag
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { prop: "APIGravity", label: "API Gravity" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                "auto-complete": "off",
                                placeholder: "Please fill in",
                              },
                              model: {
                                value: _vm.pageData.APIGravity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageData, "APIGravity", $$v)
                                },
                                expression: "pageData.APIGravity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showFlag
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "oilAnalysis",
                              label: "Oil Analysis",
                            },
                          },
                          [
                            _c("file-upload", {
                              attrs: {
                                "default-file-list": _vm.pageData.oilAnalysis
                                  ? [
                                      {
                                        name: _vm.pageData.oilAnalysis,
                                        uid: _vm.pageData.oilAnalysis,
                                      },
                                    ]
                                  : undefined,
                              },
                              on: {
                                onSuccess: function ($event) {
                                  return _vm.handleFileSuccess(
                                    $event,
                                    "oilAnalysis"
                                  )
                                },
                                onRemove: function ($event) {
                                  return _vm.handleFileRemove(
                                    $event,
                                    "oilAnalysis"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "wellLisence", label: "Well Lisence" } },
                      [
                        _c("file-upload", {
                          attrs: {
                            "default-file-list": _vm.pageData.wellLisence
                              ? [
                                  {
                                    name: _vm.pageData.wellLisence,
                                    uid: _vm.pageData.wellLisence,
                                  },
                                ]
                              : undefined,
                          },
                          on: {
                            onSuccess: function ($event) {
                              return _vm.handleFileSuccess(
                                $event,
                                "wellLisence"
                              )
                            },
                            onRemove: function ($event) {
                              return _vm.handleFileRemove($event, "wellLisence")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.type !== "edit" ? _c("Share", { ref: "ShareCom" }) : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }